import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

const MapComponent = ({ address, onAddressChange, apiKey }) => {
  const [markerPosition, setMarkerPosition] = useState({ lat: 19.4326, lng: -99.1332 });
  const mapRef = useRef(null);
  const geocoderRef = useRef(null);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: apiKey,
    libraries: ['places'],
  });

  useEffect(() => {
    if (isLoaded && !geocoderRef.current) {
      geocoderRef.current = new window.google.maps.Geocoder();
    }
  }, [isLoaded]);

  useEffect(() => {
    if (!address || !geocoderRef.current) return;

    geocoderRef.current.geocode(
      { address },
      (results, status) => {
        if (status === 'OK' && results[0]) {
          const location = results[0].geometry.location;
          const newPosition = { lat: location.lat(), lng: location.lng() };
          setMarkerPosition(newPosition);
          mapRef.current?.panTo(newPosition);
        }
      }
    );
  }, [address]);

  const handleMapClick = (event) => {
    if (!geocoderRef.current) return;

    const clickedPosition = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng()
    };

    setMarkerPosition(clickedPosition);

    geocoderRef.current.geocode(
      { location: clickedPosition },
      (results, status) => {
        if (status === 'OK' && results[0]) {
          onAddressChange(results[0].formatted_address);
        }
      }
    );
  };

  if (loadError) return <div className="map-error">Error al cargar el mapa</div>;
  if (!isLoaded) return <div className="map-loading">Cargando mapa...</div>;

  return (
    <GoogleMap
      mapContainerStyle={{
        height: '300px',
        width: '100%',
        borderRadius: '10px',
        marginTop: '10px'
      }}
      zoom={12}
      center={markerPosition}
      onClick={handleMapClick}
      onLoad={map => mapRef.current = map}
    >
      <Marker position={markerPosition} />
    </GoogleMap>
  );
};

export default MapComponent;